export default __webpack_public_path__ + "static/media/goya-logo.65ddd296.png";